import { FormFieldProps } from './types';
import { useFormField } from './use-form-field';

export type FormHiddenFieldProps<T = unknown> = Omit<
  FormFieldProps<{ id: string; onChange: (value: unknown) => void; defaultValue?: unknown }, T>,
  'label'
>;

export function FormHiddenField<T>(props: FormHiddenFieldProps<T>) {
  useFormField({ label: '', ...props });

  return null;
}
